import { ArrowRight, ArrowDown } from "lucide-react";
import type { LandingPageSection } from "@/api/admin";

interface StepsSectionProps {
  section: LandingPageSection;
}

export function StepsSection({ section }: StepsSectionProps) {
  const steps = section.steps ?? [];

  return (
    <div className="space-y-14">
      {section.heading && (
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center ">
          {section.heading}
        </h2>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
        {steps.map((step, i) => (
          <div key={step.id ?? i} className="relative flex flex-col items-center text-center gap-4">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden">
                {step.icon_url ? (
                  <img
                    src={step.icon_url}
                    alt=""
                    className="w-24 h-24 object-contain"
                  />
                ) : (
                  <div className="w-9 h-9 rounded-full bg-white/10" />
                )}
              </div>
              <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-[#00d9d9] text-black text-xs font-bold flex items-center justify-center">
                {i + 1}
              </div>
            </div>
            {step.text && (
              <p className="text-sm text-white/70 leading-snug whitespace-pre-line">
                {step.text}
              </p>
            )}

            {i < steps.length - 1 && (
              <>
                <ArrowDown
                  size={22}
                  className="text-white/20 shrink-0 md:hidden mt-2"
                />
                <ArrowRight
                  size={22}
                  className="text-white/20 shrink-0 hidden md:block absolute top-10 -right-4 translate-x-1/2"
                />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
